import { Tooltip as Tooltip_ } from "@chakra-ui/react"
import { forwardRef } from "react"
export const Tooltip = forwardRef(({...props}, ref) => {
    return <Tooltip_ hasArrow placement="top" ref={ref} {...props}>{props?.children}</Tooltip_>
});